import React, {useEffect, useState } from "react";
import {
  
} from "@carbon/react";
import {} from "@carbon/icons-react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar/Sidebar";
import Topbar from "../components/topbar/Topbar";
import {useUser} from "../context/UserContext";
import { Navigate } from "react-router-dom";



export default function AdminLayout() {
  const navigate = useNavigate();
const { user, isLoggedIn } = useUser();
const [isSidebarOpen, setIsSidebarOpen] = useState(false);

const token = localStorage.getItem("jwt_token");

  const onMenuClick = () => {
    setIsSidebarOpen((prev) => !prev);
  }
  

useEffect(() => {
  if (!isLoggedIn) {
    navigate("/login", { replace: true });
  }
}, [isLoggedIn, navigate]);

useEffect(() => {
  const handlePageShow = (event) => {
    const token = localStorage.getItem("jwt_token");

    if ((event.persisted ||
        performance.getEntriesByType("navigation")[0]?.type === "back_forward") &&
        !token) {
      navigate("/login", { replace: true });
    }
  };


  window.addEventListener("pageshow", handlePageShow);

  return () => {
    window.removeEventListener("pageshow", handlePageShow);
  };
}, [navigate]);
  if (!token || !user) {
  return <Navigate to="/login" replace />;
}


  return (
    <div className="admin-layout">
      <Topbar onMenuClick={onMenuClick} isSidebarOpen={isSidebarOpen} />
      {/* Required Carbon content wrapper */}
      <div className="bx--content admin-body">
        <Sidebar 
          isExpanded={isSidebarOpen} 
          onClose={() => setIsSidebarOpen(false)} 
        />
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>

  ); 
}
